import React from 'react'
import Header from '../components/header';
import Banner from '../components/Banner';
import Footer from '../components/footer';

function Home() {
  return (
    <main>
        <Header/>
        <Banner/>
        <Footer/>
    </main>
  )
}

export default Home